import React, { useEffect } from 'react';
import { useAccount, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from 'authConfig';
import { InteractionStatus } from '@azure/msal-browser';
import { Col, Row, Spin, Typography } from 'antd';
import globalStyles from 'common/global.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { refreshAdUserSession } from 'common/helpers';
import { useDispatch } from 'react-redux';

const { Paragraph } = Typography;

const SignIn: React.FC<{}> = ({}) => {
  const { instance, inProgress, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();
  const dispatch = useDispatch();

  // extract query string parameters
  const location = useLocation();
  const urlParameters = new URLSearchParams(location.search);
  const returnTo = urlParameters.get('return_to');

  // each time this page is loaded, remove the refreshadusersession storage item to prevent an infinite loop
  useEffect(() => {
    localStorage.removeItem('refreshadusersession');
  }, []);

  const postAuthorizationAction = () => {
    const path = returnTo ?? '/pages';
    history.push(path);
  };

  useEffect(() => {
    // timeout prevents the challenge from being triggered just before a page redirect, which we don't want because it breaks the auth flow
    const timer = setTimeout(() => {
      // ensure we only trigger login popup if the current interaction status for Msal instance is None
      if (inProgress === InteractionStatus.None && !isAuthenticated) {
        localStorage.setItem('ispublicuser', 'true');
        localStorage.removeItem('iswellsfargouser');

        instance.loginRedirect(loginRequest);
      } else if (
        inProgress === InteractionStatus.None &&
        isAuthenticated &&
        account
      ) {
        refreshAdUserSession(
          instance,
          account,
          dispatch,
          postAuthorizationAction,
        );
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [instance, inProgress, isAuthenticated]);

  return (
    <>
      <Row type="flex" justify="center" align="middle">
        <Col xs={23} md={18} lg={12}>
          <Row type="flex" justify="center" align="middle">
            <Col
              xs={24}
              md={14}
              lg={12}
              className={`${globalStyles.textCenter} ${globalStyles.topSpacing}`}
            >
              <Spin spinning={true} size="large" tip="Authenticating..."></Spin>
            </Col>
          </Row>

          <Paragraph className={globalStyles.textCenter}>
            You will be redirected shortly!
          </Paragraph>

          <Paragraph>
            Prior to ordering any searches, our system allows clients to confirm
            any property in NY State using Address, Parcel ID, and/or Owners
            Name.
          </Paragraph>
        </Col>
      </Row>
    </>
  );
};

export default SignIn;
